function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm9.544-15.024c2.097-1.248 3.238-3.719 3.527-6.164.22-1.85-.136-3.799-1.15-5.356-.977-1.486-2.585-2.577-4.343-2.793a.175.175 0 01-.135-.26 26.45 26.45 0 014.015-5.45 6.79 6.79 0 00-3.298-1.973 22.197 22.197 0 01-1.778 6.52.149.149 0 01-.247.038c-.105-.12-.21-.244-.319-.371-.492-.578-1.022-1.2-1.62-1.552-4.114-2.415-9.873-1.197-12.471 3.01-1.166 1.886-1.518 4.099-1.87 6.312-.137.865-.274 1.73-.46 2.576a21.32 21.32 0 01-2.025 5.471 1.705 1.705 0 01-.07.12c-.068.11-.15.243-.15.33 0 .216.343.357.568.433 2.772.917 5.586 1.774 8.49 2.122 3.034.361 7.72.22 9.108-.717.047-.03.021-.098-.03-.098-2.27.022-3.756-1.052-4.074-2.907-.331-1.927.628-3.663 2.122-4.47 1.494-.802 3.582-.666 4.835.48 1.09.993 1.557 2.784.9 4.32-.08.182-.257.37-.393.516-.084.09-.153.163-.172.206-.038.085.05.17.136.128l.134-.07c.237-.121.679-.348.77-.401z",
  fill: "#938666"
});

var SvgMarkLeaf = function SvgMarkLeaf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarkLeaf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mark-leaf.6d3728d0.svg";
export { ForwardRef as ReactComponent };